<script>
export default {
    name: 'IlluEnseignant',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-enseignant"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M13.28 26.765c1.15-4.761 2.637-7.142 4.46-7.142 2.964 0 2.038 2.906 4.149 3.142C24 23 29 9.5 29 20.5V27a1 1 0 01-1 1H14.251a1 1 0 01-.972-1.235z"
                :fill="primaryColor"
                class="primary-color"
            />
            <circle
                :stroke="secondaryColor"
                class="secondary-color"
                cx="40.5"
                cy="19.5"
                r="3"
            />
            <path
                d="M32 25.5h11a2 2 0 012 2V35h0-4.377a2 2 0 01-1.957-1.588L37 25.5h0"
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
            />
            <path
                d="M32 35H13a4 4 0 01-4-4V13a4 4 0 014-4h38a4 4 0 014 4v18a4 4 0 01-4 4h-6 0"
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
            />
            <rect
                :stroke="secondaryColor"
                class="secondary-color"
                x="12.5"
                y="39.5"
                width="5"
                height="6"
                rx="2.5"
            />
            <path
                d="M17.046 47.92L15 50.26l-2.046-2.34a5.855 5.855 0 00-2.39 1.886c-.666.89-1.064 1.95-1.064 3.012 0 .194.106.357.26.504.247.233.613.423 1.054.583 1.1.4 2.644.595 4.186.595 1.542 0 3.085-.195 4.186-.595.44-.16.807-.35 1.053-.583.155-.147.261-.31.261-.504 0-1.062-.398-2.122-1.063-3.012a5.855 5.855 0 00-2.39-1.886z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <rect
                :stroke="secondaryColor"
                class="secondary-color"
                x="29.5"
                y="39.5"
                width="5"
                height="6"
                rx="2.5"
            />
            <rect
                :stroke="secondaryColor"
                class="secondary-color"
                x="46.5"
                y="39.5"
                width="5"
                height="6"
                rx="2.5"
            />
            <path
                d="M34.046 47.92L32 50.26l-2.046-2.34a5.855 5.855 0 00-2.39 1.886c-.666.89-1.064 1.95-1.064 3.012 0 .194.106.357.26.504.247.233.613.423 1.054.583 1.1.4 2.644.595 4.186.595 1.542 0 3.085-.195 4.186-.595.44-.16.807-.35 1.053-.583.155-.147.261-.31.261-.504 0-1.062-.398-2.122-1.063-3.012a5.855 5.855 0 00-2.39-1.886zM51.046 47.92L49 50.26l-2.046-2.34a5.855 5.855 0 00-2.39 1.886c-.666.89-1.064 1.95-1.064 3.012 0 .194.106.357.26.504.247.233.613.423 1.054.583 1.1.4 2.644.595 4.186.595 1.542 0 3.085-.195 4.186-.595.44-.16.807-.35 1.053-.583.155-.147.261-.31.261-.504 0-1.062-.398-2.122-1.063-3.012a5.855 5.855 0 00-2.39-1.886z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
        </g>
    </svg>
</template>
